import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=08f41823"
import script from "./buttons.js?vue&type=script&lang=js&external"
export * from "./buttons.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports